import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/styles';

export const useIsMobile = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  return isMobile;
};
